import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/auth';
import { AutoCompleteBox, FormButton, SelectInputBox } from "../commoncomponents/InputBox";
import { Table } from '../commoncomponents/Table';
//loder
import BlurLoader from "../Loder/BlurLoader";
//react toast 
import { toast } from 'react-toastify';
//common Data
import { API_SERVER } from '../../Utils';
//services
import { getCommonData, getMasterData } from '../../apiservices/CommonServices';
import { post } from '../../apiservices/service';
import { Token } from '../Common/Common';

function DownloadDocumentZip() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();
    const TokenData = Token()
    //initial state
    const [recipe, setRecipe] = useState({
        employee: '',
        Branch: '',
        DocTypeID: '',
        SubDocTypeID: ''
    })

    const [result, setResult] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [isUpdate, setIsUpdate] = useState(false);
    const [branchAllData, setBranchAllData] = useState([])
    const [employeeAllData, setEmployeeAllData] = useState([])
    const [errors, setErrors] = useState({});
    const [showTable, setShowTable] = useState(false)
    const [documentTypeAllData, setDocumentTypeAllData] = useState([])
    const [documentSubTypeAllData, setDocumentSubTypeAllData] = useState([])

    //Get branch Data for AutoComplete
    const GetBranchData = (value) => {
        setBranchAllData([])
        let temp = {
            Type: "GetBranch",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setBranchAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setBranchAllData(data)
                }
            }
        });
    }

    //Get Employee Data for AutoComplete
    const GetEmployeeData = (value) => {
        setEmployeeAllData([])
        let temp = {
            Type: "GetEmployee",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setEmployeeAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setEmployeeAllData(data)
                }
            }
        });
    }

    const DocumentTypeAllData = () => {
        let temp = {
            Type: "DocumentType",
            Prefix: '',
            ContextKey: "",
            ContextKey2: ""
        }
        setLoading(true)
        getMasterData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setDocumentTypeAllData(data)
                    console.log(data)
                }
            }
        });
    }

    const DocumentSubTypeAllData = (value) => {
        let temp = {
            Type: "DocumentSubType",
            Prefix: '',
            ContextKey: value || '',
            ContextKey2: ""
        }
        setLoading(true)
        getMasterData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setDocumentSubTypeAllData([])
                } else {
                    setLoading(false)
                    let data = res.dataList
                    setDocumentSubTypeAllData(data)
                }
            }
        });
    };

    //Submit Handler
    const handleSearch = (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let temp = {
            PageIndex: PageIndex.toString(),
            SearchText: "",
            StartValue: "1",
            SearchFieldValue: "",
            Type: "s",
        }
        setLoading(true)
        post(`${API_SERVER}api/Report/ShowDocumentZip`, { ...TokenData, ...temp, ...sortConfig, ...recipe }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    toast.error(res.Message)
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false);
                    setResult({ ...res });
                    setShowTable(true);
                }
            }
        });
    }

    const handleSubmit = () => {
        setLoading(true)
        post(`${API_SERVER}api/Report/InsertDocumentZip`, { ...TokenData, ...recipe }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    inputrefs.current[res.focus].focus();
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    handleSearch();
                    toast.success(res.message);
                }
            }
        });
    }


    const handleChange1 = (event, value) => {
        handleSubmit(value);
    };

    //Change Handler
    const HandleChange = (prop, value) => {
        if (prop === 'DocTypeID') {
            DocumentSubTypeAllData(value)
            setRecipe({ ...recipe, DocTypeID: value, SubDocTypeID: '' })
        } else {
            setRecipe(recipe => ({ ...recipe, [prop]: value }))

        }
    }

    let BranchData = []
    for (let i = 0; i < branchAllData.length; i++) {
        let mydata = branchAllData[i]?.values
        BranchData.push(mydata)
    };

    let EmployeeData = []
    for (let i = 0; i < employeeAllData.length; i++) {
        let mydata = employeeAllData[i]?.values
        EmployeeData.push(mydata)
    };

    //Start Export functionality
    let ExportRequest = {
        ...TokenData,
        ...sortConfig,
        ...recipe,
        Type: 'E',
        PageIndex: '1',
    }
    //End Export functionality

    useEffect(() => {
        inputrefs.current['txtBranch'].focus();
        document.title = 'Viva HRMS : Download Document Zip';
        GetEmployeeData();
        DocumentTypeAllData();

        const intervalCall = setInterval(() => {
            handleSearch();
        }, 10000);
    }, [sortConfig, isUpdate])

    const HandleDownloadZip = (Path) => {
        setLoading(true);
        post(`${API_SERVER}api/Report/DownloadDocumentZip`, { ...ExportRequest, Path: Path }, (res) => {
            if (res && res.Status) {
                if (res.Status === "SUCCESS") {

                    const byteCharacters = atob(res.ZipPath);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/zip' });

                    // Create a link and set the URL using createObjectURL
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = "Employee Document.zip"; // Name of the file to be downloaded
                    document.body.appendChild(link);
                    setLoading(false);
                    // Trigger the download by programmatically clicking the link
                    link.click();
                    // Clean up by removing the link
                    document.body.removeChild(link);
                }
                else if (res.Status === "ERROR") {
                    toast.error(res.Message)
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                }
            }
        });
    }

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">Download Document Zip</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtDocTypeID'].focus() };
                            }}
                            label='Branch'
                            placeholder="Branch"
                            maxLength='50'
                            options={BranchData}
                            id='txtBranch'
                            error={errors.Branch}
                            inputValue={recipe.Branch ? recipe.Branch : ''}
                            onInputChange={(event, newInputValue) => {
                                HandleChange('Branch', newInputValue)
                                GetBranchData(newInputValue)
                            }}
                        />

                        <SelectInputBox
                            label='Document Type'
                            inputrefs={inputrefs}
                            id="txtDocTypeID"
                            value={recipe.DocTypeID}
                            error={errors.DocTypeID}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtSubDocTypeID'].focus() };
                            }}
                            onChange={(e) => HandleChange('DocTypeID', e.target.value)}
                            children={<>
                                <option value="">--Select Document Type--</option>
                                {documentTypeAllData.map((opt, index) => <option key={index} value={opt.id} >{opt.name}</option>)}
                            </>}
                        />

                        <SelectInputBox
                            label='Document Sub Type'
                            inputrefs={inputrefs}
                            id="txtSubDocTypeID"
                            value={recipe.SubDocTypeID}
                            error={errors.SubDocTypeID}
                            onKeyDown={(e) => {
                            }}
                            onChange={(e) => {
                                HandleChange('SubDocTypeID', e.target.value)
                            }}
                            children={<>
                                <option value="">--Select DocumentSub Type--</option>
                                {documentSubTypeAllData !== null && documentSubTypeAllData.map((opt, index) => <option key={index} value={opt.id} >{opt.name}</option>)}
                            </>}
                        />

                        <AutoCompleteBox
                            inputrefs={inputrefs}
                            label='Employee'
                            placeholder="Employee"
                            maxLength='50'
                            options={EmployeeData}
                            id='txtEmployee'
                            key='txtEmployee'
                            inputValue={recipe.employee ? recipe.employee : ''}
                            onInputChange={(event, newInputValue) => {
                                GetEmployeeData(newInputValue)
                                HandleChange('employee', newInputValue)
                            }}
                        />

                        <FormButton
                            saveButtonIcon='fa-search'
                            save={false}
                            Export={false}
                            Download={true}
                            handleDownload={handleSubmit}
                        />
                    </div>
                </div>
            </div>
            {showTable &&
                <Table
                Filter={false}
                Action={true}
                Token={TokenData}
                PageName='ShowDocumentZip'
                tableData={result}
                loading={loading}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleDownloadZip={HandleDownloadZip}
                />
            }
            {loading && < BlurLoader />}
        </>
    )
}

export default DownloadDocumentZip